import SubjectSubTable from './SubjectSubTable.component';

export default SubjectSubTable;
